import { TERMINAL_HOSTED_ZONE_NAME } from '@/env';

export const HYPERLIQUID_IS_TESTNET =
  import.meta.env.VITE_HYPERLIQUID_IS_TESTNET === 'true';
export const HYPERLIQUID_BUILDER_ADDRESS =
  '0x82E719B1Ce586614a4C06D113d922700C01A131b';

const localProxyExchange = import.meta.env.VITE_TERMINAL_LOCAL_EXCHANGE;
const localProxyDomain = import.meta.env.VITE_TERMINAL_LOCAL_PROXY_DOMAIN;
const localUserProxyExchange = import.meta.env
  .VITE_TERMINAL_LOCAL_USER_EXCHANGE;
const localUserProxyDomain = import.meta.env
  .VITE_TERMINAL_LOCAL_USER_PROXY_DOMAIN;

const proxyDomain = (exchange: string) => {
  if (localProxyExchange === exchange && localProxyDomain) {
    return localProxyDomain;
  }
  if (localUserProxyExchange === exchange && localUserProxyDomain) {
    return localUserProxyDomain;
  }
  return `${exchange}.proxy-api.${TERMINAL_HOSTED_ZONE_NAME}`;
};

const isLocalProxyDomain = (domain: string) =>
  domain.startsWith('localhost:') || domain.startsWith('127.0.0.1:');

export const proxyHttpUrl = (domain: string) =>
  `${isLocalProxyDomain(domain) ? 'http' : 'https'}://${domain}`;

export const proxyWsUrl = (domain: string) =>
  `${isLocalProxyDomain(domain) ? 'ws' : 'wss'}://${domain}/`;

export const BINANCE_PROXY_DOMAIN = proxyDomain('binance');
export const BYBIT_PROXY_DOMAIN = proxyDomain('bybit');
export const POLYMARKET_PROXY_DOMAIN = proxyDomain('polymarket-public');
export const POLYMARKET_USER_PROXY_DOMAIN = proxyDomain('polymarket-user');
export const POLYMARKET_CATALOG_DOMAIN = proxyDomain(
  'polymarket-public-catalog',
);
export const KALSHI_PROXY_DOMAIN = proxyDomain('kalshi');
export const HYPERLIQUID_PROXY_DOMAIN = proxyDomain('hyperliquid');
